import { useDispatch } from 'react-redux';
import { analyzeLogout } from '@client/analytics/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useLogoutAnalytics = (): typeof analyzeLogout => {
  const dispatch = useDispatch();

  return bindActionCreators(analyzeLogout, dispatch);
};
